module.exports = __webpack_public_path__ + "img/icon3.44250ce1.png";